import React from 'react';

// set the defaults
const AuthContext = React.createContext({
  isAuthenticated: false,
  setIsAuthenticated: () => {}
});

export default AuthContext;
